import emotionStyled from '@emotion/styled'
import { TextField } from '@material-ui/core'

export const InputStyled = emotionStyled(TextField)`
  margin: 0 !important;
  & input[type="number"] {
    -moz-appearance: textfield; /* Hilangkan spinner di Firefox */
  }
  & input[type="number"]::-webkit-outer-spin-button,
  & input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none; /* Hilangkan spinner di Chrome/Safari */
    margin: 0;
  }
  & > .MuiInputBase-root > textarea {
    min-height: 20px !important;
  }
`